<div class="modal">
    <div class="modal-content">
        <h2>Da li ste sigurni da želite da poništite zahtjev ?</h2>
        <div class="button-container">
            <button class="btn btn-primary confirm-button" (click)="confirm()" [disabled]="pending">
                <span *ngIf="!pending">Potvrdi</span>
                <span *ngIf="pending"><div class="loader"></div></span>
            </button>
            <div class="button-space"></div>
            <button class="btn btn-secondary cancel-button" (click)="cancel()">Otkaži</button>
        </div>
    </div>
</div>
